import React from 'react';

const ViewToggle = ({ viewMode, onViewChange }) => {
  return (
    <div className="flex items-center bg-gray-100 dark:bg-gray-700 rounded-xl p-1 shadow-sm">
      <button
        onClick={() => onViewChange('card')}
        className={`flex items-center px-3 py-2 rounded-lg transition-all duration-200 ${
          viewMode === 'card'
            ? 'bg-grafokett-blue text-white shadow-md'
            : 'text-gray-600 dark:text-gray-400 hover:text-grafokett-blue dark:hover:text-grafokett-blue hover:shadow-sm'
        }`}
      >
        <i className="fas fa-th mr-2"></i>
        Cards
      </button>
      <button
        onClick={() => onViewChange('list')}
        className={`flex items-center px-3 py-2 rounded-lg transition-all duration-200 ${
          viewMode === 'list'
            ? 'bg-grafokett-blue text-white shadow-md'
            : 'text-gray-600 dark:text-gray-400 hover:text-grafokett-blue dark:hover:text-grafokett-blue hover:shadow-sm'
        }`}
      >
        <i className="fas fa-list mr-2"></i>
        List
      </button>
    </div>
  );
};

export default ViewToggle;
